import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import i18n from '../i18n';
import ModalDialogCloseButton from './ModalDialogCloseButton';

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1200;
  background: ${({ colors }) => colors?.webOverlay || 'rgba(0, 0, 0, 0.5)'};
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

const ModalCard = styled.div`
  width: 100%;
  max-width: 660px;
  border-radius: 15px;
  padding: 0;
  background: #ffffff;
  border: none;
  box-shadow: 0 24px 56px rgba(13, 18, 44, 0.24);
  overflow: hidden;
`;

const ModalWrap = styled.div`
  width: 100%;
  max-width: 660px;
  position: relative;
`;

const Title = styled.h3`
  margin: 0;
  padding: 14px 40px 10px 40px;
  color: ${({ colors }) => colors?.webDarkBlue || '#45446b'};
  font-size: 26px;
  font-weight: 600;
  font-family: 'Montserrat', sans-serif;
`;

const Subtitle = styled.p`
  margin: 0;
  padding: 0 40px 14px 40px;
  color: #4b4b4b;
  font-size: 14px;
  line-height: 1.45;
  font-family: 'Montserrat', sans-serif;
`;

const ContractList = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 20px 20px 20px;
  gap: 0;
`;

const ContractButton = styled.button`
  width: 100%;
  text-align: left;
  border-radius: 0;
  border: none;
  border-bottom: 1px solid rgba(69, 68, 107, 0.12);
  background: #ffffff;
  color: #1f1f1f;
  padding: 16px 20px;
  font-size: 15px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.12s ease;

  &:hover {
    background: #f8f8fb;
  }

  &:first-child {
    border-top: 1px solid rgba(69, 68, 107, 0.12);
  }
`;

const ContractSelectionModal = ({ isOpen, contracts, onSelect, onClose, colors }) => {

  if (!isOpen) {
    return null;
  }

  return (
    <Overlay onClick={onClose} colors={colors}>
      <ModalWrap>
        <ModalDialogCloseButton onClick={onClose} />
        <ModalCard colors={colors} onClick={(event) => event.stopPropagation()}>
          <Title colors={colors}>{i18n('select_contract_title', 'Select Contract')}</Title>
          <Subtitle>
            {i18n('select_contract_subtitle', 'Choose the contract to use for this order.')}
          </Subtitle>

          <ContractList>
            {contracts.map((contract) => (
              <ContractButton
                key={contract.id}
                type="button"
                colors={colors}
                onClick={() => onSelect(contract)}
              >
                {contract.name}
              </ContractButton>
            ))}
          </ContractList>
        </ModalCard>
      </ModalWrap>
    </Overlay>
  );
};

ContractSelectionModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  contracts: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string,
  })).isRequired,
  onSelect: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  colors: PropTypes.object,
};

ContractSelectionModal.defaultProps = {
  onClose: () => {},
};

export default ContractSelectionModal;
